import { render, staticRenderFns } from "./aRoomDetailRepair.vue?vue&type=template&id=57df5c24&scoped=true"
import script from "./aRoomDetailRepair.vue?vue&type=script&lang=js"
export * from "./aRoomDetailRepair.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailRepair.vue?vue&type=style&index=0&id=57df5c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df5c24",
  null
  
)

export default component.exports